// The Inspections vertical is served by the standalone inspections-webapp
// (nginx routes /inspections/* on the org subdomains to its dev server on
// :3006). flex2-webapp no longer mounts the in-bundle inspections routes;
// this catch-all turns any SPA navigation into /inspections/* (system picker,
// sidebar links, login default-route) into a full page load so the browser
// actually leaves this bundle and fetches inspections-webapp's index.
//
// Without this, every in-app link to /inspections/* falls through to the
// catch-all and lands on /login.
//
// Loop guard: on hosts whose nginx does NOT route /inspections to
// inspections-webapp (e.g. personal dev instances), the reload lands straight
// back here — detect the immediate re-entry and show a note instead of
// reloading forever.
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LAST_HANDOFF_KEY = "inspectionsHandoffAt";

export default function InspectionsHandoff() {
  const { pathname, search } = useLocation();
  const [looping, setLooping] = useState(false);

  useEffect(() => {
    const last = Number(sessionStorage.getItem(LAST_HANDOFF_KEY) || 0);
    if (Date.now() - last < 5000) {
      setLooping(true);
      return;
    }
    sessionStorage.setItem(LAST_HANDOFF_KEY, String(Date.now()));
    window.location.replace(pathname + search);
  }, [pathname, search]);

  if (!looping) return null;
  return (
    <div style={{ padding: 40, fontFamily: "sans-serif" }}>
      The Inspections portal is served by inspections-webapp, but this
      host&apos;s nginx isn&apos;t routing <code>/inspections</code> to it —
      see /etc/nginx/sites-enabled/liftconnectpro.dev for the reference block.
    </div>
  );
}
